import { combineReducers } from '@reduxjs/toolkit'

import { toastsSlice as toasts } from 'core/components/Toaster'

export default combineReducers({
  toasts,
})
